var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefitsIconBusiness = function SvgBenefitsIconBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75v-5H2.5v22.5h25V8.75H15Zm-7.5 15H5v-2.5h2.5v2.5Zm0-5H5v-2.5h2.5v2.5Zm0-5H5v-2.5h2.5v2.5Zm0-5H5v-2.5h2.5v2.5Zm5 15H10v-2.5h2.5v2.5Zm0-5H10v-2.5h2.5v2.5Zm0-5H10v-2.5h2.5v2.5Zm0-5H10v-2.5h2.5v2.5Zm12.5 15H15v-2.5h2.5v-2.5H15v-2.5h2.5v-2.5H15v-2.5h10v12.5Zm-2.5-10H20v2.5h2.5v-2.5Zm0 5H20v2.5h2.5v-2.5Z",
    fill: "#43A047"
  })));
};
export default SvgBenefitsIconBusiness;